import React from 'react';
import { exerciseStructure, photos, sampleMeta, sampleRows } from '../data/content';
import { OfferLink } from './ui/OfferLink';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function LookInside() {
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-111" data-mp="21m959k1bsu8e">
      <div className="mx-auto max-w-5xl" data-id="element-112" data-mp="25och49rwq0u7">
        <Eyebrow data-id="element-113" data-mp="25n1c66mq6n1i">Look inside</Eyebrow>
        <SectionTitle data-id="element-114" data-mp="1rx7o3qj1o6su">
          See how the exercises are <Mark data-id="element-115" data-mp="1rwfqyb9su10g">organized inside the system</Mark>
        </SectionTitle>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-steel md:text-base" data-id="element-116" data-mp="1wofzgs3xq28n">
          Instead of showing only an exercise name, the material gives you practical information you can actually
          follow.
        </p>

        <div className="mt-8 grid items-center gap-8 lg:grid-cols-5" data-id="element-117" data-mp="1mye8nsk765q1">
          <OfferLink className="mx-auto w-full max-w-xs lg:col-span-2" label="See the Complete Injury Rehabilitation Bundle offer" data-id="element-118" data-mp="18zenwvzt2az5">
            <img src={photos.bandRotation} alt="Adult performing a band external rotation with the elbow close to the body" className="aspect-[4/5] w-full rounded-3xl object-cover shadow-xl transition-transform duration-300 ease-out group-hover:scale-[1.01]" data-id="element-119" data-mp="1dzj1oe9bwrlo" />
          </OfferLink>

          <article className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-xl lg:col-span-3" data-id="element-120" data-mp="f1968uitut7f">
            <header className="bg-navy p-5" data-id="element-121" data-mp="3ngss38h659cg">
              <p className="text-[10px] font-extrabold uppercase tracking-wider text-brand-light" data-id="element-122" data-mp="3nfhszlyo4pro">Sample exercise</p>
              <h3 className="mt-1 font-display text-base font-black uppercase text-white md:text-lg" data-id="element-123" data-mp="11zohqez3r1c">
                Band External Rotation
              </h3>
            </header>
            <dl className="grid grid-cols-2 gap-px bg-navy/10" data-id="element-124" data-mp="3seknich0vdle">
              {sampleMeta.map(([label, value]) => <div key={label} className="bg-white p-4" data-id="element-125" data-mp="2zrztt5d2qpeo">
                  <dt className="text-[10px] font-extrabold uppercase tracking-wider text-steel" data-id="element-126" data-mp="2zrgnklwsdpgh">{label}</dt>
                  <dd className="mt-0.5 text-sm font-bold text-navy" data-id="element-127" data-mp="13oleq8se6e24">{value}</dd>
                </div>)}
            </dl>
            <div className="border-t border-navy/10 px-5 py-1" data-id="element-128" data-mp="1dewtyrhj09ob">
              <table className="w-full text-left text-sm" data-id="element-129" data-mp="1dfgaq4vfws0r">
                <tbody data-id="element-130" data-mp="1hgi3c2uuq5tr">
                  {sampleRows.map(([label, value]) => <tr key={label} className="border-b border-navy/10 last:border-b-0" data-id="element-131" data-mp="kqiv69im59bp">
                      <th scope="row" className="w-32 py-2.5 pr-3 align-top text-[10px] font-extrabold uppercase tracking-wider text-brand" data-id="element-132" data-mp="pospyj0fe7ws">
                        {label}
                      </th>
                      <td className="py-2.5 font-semibold text-navy" data-id="element-133" data-mp="ynnyi1qxzu39">{value}</td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="border-t border-navy/10 bg-canvas px-5 py-4" data-id="element-134" data-mp="2a32t4yvoi9v7">
              <p className="font-display text-[11px] font-black uppercase tracking-wider text-navy" data-id="element-135" data-mp="2k7szdgy48058">
                Every exercise can include:
              </p>
              <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-136" data-mp="2aisytt3yswox">
                {exerciseStructure.map(item => <li key={item} className="rounded-md border border-navy/10 bg-white px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-steel" data-id="element-137" data-mp="26hzch4667py5">
                    {item}
                  </li>)}
              </ul>
            </div>
          </article>
        </div>
      </div>
    </section>;
}